import { UserLanguageType } from "@Components/Modules/Helpers";

export const browserStatics: {
    browserOs: string;
    language: UserLanguageType;
    imageSupport: string;
    culture: "pl-PL" | "en-US";
    imageSupportFormat: string;
    isMobileApp: boolean;
    shouldUserSeeAds: boolean;
} = {
    browserOs: null,
    language: UserLanguageType.Polish,
    culture: "pl-PL",
    imageSupport: null,
    isMobileApp: false,
    imageSupportFormat: null,
    shouldUserSeeAds: true,
};
